module.exports = __webpack_public_path__ + "img/c0b74ca.png";